import { Skeleton } from "@/components/atoms";
import { PricingProfilePanel, usePricingProfileContext } from "@/components/organisms";
import { Restricted } from "@/components/pages/Restricted/Restricted";
import { StateRates } from "./StateRates";
import { ZoneRates } from "./ZoneRates";

export const PricingProfile = () => {
  const { isFetching, isRestricted } = usePricingProfileContext();

  if (isFetching) {
    return (
      <div className="flex flex-1 flex-col min-h-[calc(100vh-120px)] px-5 py-4">
        <Skeleton />
      </div>
    );
  }

  return (
    <div className="flex flex-1 flex-col min-h-[calc(100vh-120px)] px-5 py-4">
      {isRestricted ? <Restricted /> : <PricingProfilePanel />}
    </div>
  );
};

PricingProfile.StateRates = StateRates;
PricingProfile.ZoneRates = ZoneRates;